var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0673 19H14.2006V14.825L15.9073 16.425L17.4006 15L13.1339 11L8.86725 15L10.3873 16.4L12.0673 14.825V19ZM6.73392 22C6.14725 22 5.64503 21.8042 5.22725 21.4125C4.80947 21.0208 4.60059 20.55 4.60059 20V4C4.60059 3.45 4.80947 2.97917 5.22725 2.5875C5.64503 2.19583 6.14725 2 6.73392 2H15.2673L21.6673 8V20C21.6673 20.55 21.4584 21.0208 21.0406 21.4125C20.6228 21.8042 20.1206 22 19.5339 22H6.73392ZM14.2006 9V4H6.73392V20H19.5339V9H14.2006Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.d8ea9723b5ccb9e1b6f4d1995e44ff46.svg";
export { ForwardRef as ReactComponent };